import { ServerIntegrationSend } from "../../Everou/_modelsTS/Integration";
import { ServiceHelper } from "../../Everou/_services/ServiceHelper";
import { PMS_API_URLS } from "../_constants/PMS_API_URLS";

export const PMSIntegrationsService = {
    list,
    create,
    rename,
    deleteIntegration,
    sync,
};

// Without organizationUid the endpoints operate on the requesting user's
// personal integration templates; with it, on the organization's shared
// ones (members only).
async function list(organizationUid?: string | null) {
    return ServiceHelper.getRequest(
        PMS_API_URLS.INTEGRATIONS,
        organizationUid ? { organization_uid: organizationUid } : undefined,
    );
}

// Force a manual sync of a single integration. Defaults to async (the
// backend answers 202 with sync_status: 'running' and resolves in background);
// pass runAsync = false to block until the sync resolves (debug/advanced).
async function sync(locUid: string, uid: string, runAsync = true) {
    return ServiceHelper.postRequest(PMS_API_URLS.INTEGRATION_SYNC, {
        loc_uid: locUid,
        uid,
        ...(runAsync === false && { run_async: false }),
    });
}

async function create(
    serverIntegration: ServerIntegrationSend,
    organizationUid?: string | null,
) {
    return ServiceHelper.putRequest(PMS_API_URLS.INTEGRATIONS, {
        ...serverIntegration,
        ...(organizationUid ? { organization_uid: organizationUid } : {}),
    });
}

// Rename only. PATCH and not the create PUT on purpose: that one runs the
// backend's per-company branch, which re-validates the credentials against the
// PMS and, for Enso Connect, mints a new apikey -- the customer's webhook would
// start being rejected because someone edited a label.
async function rename(
    uid: string,
    name: string,
    organizationUid?: string | null,
) {
    return ServiceHelper.patchRequest(PMS_API_URLS.INTEGRATIONS, {
        uid,
        name,
        ...(organizationUid ? { organization_uid: organizationUid } : {}),
    });
}

async function deleteIntegration(uid: string, organizationUid?: string | null) {
    // organization_uid travels here too: without it the backend resolves the
    // scope to the requesting user's own templates and answers 101 uid not found
    // for anything belonging to an organization.
    return ServiceHelper.deleteRequest(PMS_API_URLS.INTEGRATIONS, null, {
        uid,
        ...(organizationUid ? { organization_uid: organizationUid } : {}),
    });
}
